module.exports = {
    ADMIN_TITLE : "Profiforex Admin",
    serverWhitelist : ['https://newadmin.profiforex.com','https://profiforex.com','https://www.profiforex.com'],
    MODE: "production",
    SECRET: "2i2p23jk4ejfusdjdfjksdl3dlsdf",
    SITE_ADDRESS: "https://newadmin.profiforex.com",
    SERVER_ADDRESS: "https://newadmin.profiforex.com/graphql",
    WS_SERVER_ADDRESS: "wss://newadmin.profiforex.com/graphql",
    PORT_ADMIN_SERVER: 2360,
    HOSTNAME: "newadmin.profiforex.com"
}
